import { z } from "zod";

const zTranslationKey = z.enum([
  "EN",
  "UK",
  "DE",
  "SK",
  "RU",
  "ENGLISH",
  "UKRAINIAN",
  "GERMAN",
  "SLOVAK",
  "RUSSIAN",
  "ORDER_ACCEPTANCE",
  "INTRODUCTION",
  "CALCULATOR",
  "PROFESSIONAL_RELOCATION_SERVICES_IN_SWITZERLAND",
  "RELIABLE_LOADERS_EXPERIENCED_DRIVERS_AND_THE_BEST_PRICE_ON_THE_MARKET",
  "CALCULATE_THE_COST",
  "SUPPORT",
  "RELIABLE_SERVICE",
  "WHY_CUSTOMERS_CHOOSE_US",
  "FAVORABLE_PRICES",
  "THE_BEST_PRICES_ON_THE_MARKET_WITHOUT_HIDDEN_FEES",
  "FAST_CAR_DELIVERY",
  "TRANSPORT_WILL_ARRIVE_WITHIN_30_60_MINUTES",
  "EXPERIENCED_LOADERS",
  "QUALIFIED_EMPLOYEES_WITH_EXTENSIVE_WORK_EXPERIENCE",
  "GUARANTEE_OF_PRESERVATION",
  "YOUR_BELONGINGS_ARE_SAFE_THROUGHOUT_THE_MOVE",
  "OUR_SERVICES",
  "WE_OFFER_A_FULL_RANGE_OF_SERVICES_FOR_MOVING_APARTMENTS_OFFICES_AND_INDUSTRIAL_FACILITIES",
  "APARTMENT_MOVING",
  "OFFICE_RELOCATION",
  "INDUSTRIAL_RELOCATION",
  "MORE_DETAILS",
  "MOVING_COST",
  "FLEXIBLE_PRICING_SYSTEM_FOR_DIFFERENT_ORDERS",
  "MINIMUM",
  "FROM_PRICE",
  "CARGO_GAZELLE",
  "TRUCK",
  "T",
  "NUMBER_OF_LOADERS",
  "POPULAR",
  "PRICE_FOR_A_1_ROOM_APARTMENT",
  "PRICE_FOR_A_HOUSE_WITH_AN_AREA_OF_UP_TO_100_M",
  "PRICE_FOR_AN_OFFICE_WITH_AN_AREA_OF_UP_TO_50_M",
  "ORDER",
  "COST_CALCULATOR",
  "CALCULATE_THE_COST_OF_YOUR_MOVE",
  "SELECT_SERVICES",
  "TRANSPORTATION",
  "PACKING_THINGS",
  "LOADING_UNLOADING",
  "VEHICLE",
  "YOUR_ORDER",
  "TOTAL",
  "OUR_CUSTOMERS_REVIEWS",
  "HOW_DO_WE_WORK",
  "PREPARATION",
  "MOVING",
  "YOU_LEAVE_A_REQUEST_ON_THE_WEBSITE_OR_CALL_OUR_MANAGER_WILL_CONTACT_YOU_WITHIN_15_MINUTES",
  "WE_CALCULATE_THE_COST_AGREE_ON_A_TIME_BRING_PACKING_MATERIALS_AND_PREPARE_THE_TEAM",
  "OUR_SPECIALISTS_ARRIVE_AT_THE_APPOINTED_TIME_CAREFULLY_PACK_LOAD_AND_TRANSPORT_YOUR_BELONGINGS",
  "CONTACT_US",
  "ADDRESS",
  "PHONE",
  "EMAIL",
  "WORK_SCHEDULE",
  "SOCIAL_NETWORKS",
  "WRITE_TO_US",
  "REQUEST_SUBJECT",
  "I_D_LIKE_TO_ORDER",
  "QUESTIONS_ABOUT_SERVICES",
  "OTHER",
  "MESSAGE",
  "SEND",
  "CONVENIENT_FAST_RELIABLE",
  "ALL_RIGHTS_RESERVED",
  "THERE_WAS_AN_ERROR_LOADING_DATA",
  "TRY_AGAIN",
  "ORDER_A_MOVE",
  "CONTACT_PERSON",
  "FULL_NAME",
  "CITY",
  "FLOOR",
  "IS_THERE_AN_ELEVATOR",
  "DESCRIPTION_OF_CARGO",
  "FROM_WHERE",
  "TO",
  "SEND_AN_APPLICATION",
  "DOES_NOT_MATCH_FORMAT",
  "NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED",
  "FAILED_TO_CREATE_ORDER_REQUEST",
  "WHAT_IS_INCLUDED_IN_THE_SERVICE",
  "NO_INFORMATION_PROVIDED_AT_THIS_TIME",
  "MUST_BE_A_NUMBER",
  "MUST_BE_GREATER_THAN_N",
  "MUST_BE_AT_LEAST_N",
  "FIELD_CANNOT_BE_EMPTY",
  "FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS",
  "FIELD_MUST_MATCH_FORMAT",
  "FIELD_MUST_CONTAIN_A_NUMBER",
  "VALUE_MUST_BE_GREATER_THAN_N",
  "MINIMUM_VALUE_IS_N",
  "FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER",
  "VALUE_MUST_BE_LESS_THAN_N",
  "MAXIMUM_VALUE_IS_N",
  "PICK_A_DATE",
  "HOW_DID_YOU_HEAR_ABOUT_US",
  "PLEASE_TELL_US_HOW_YOU_FOUND_OUT_ABOUT_US",
  "WEB_SEARCH",
  "FRIEND_RECOMMENDATIONS",
  "SOCIAL_MEDIA",
  "ADVERTISING",
  "GENDER",
  "MALE",
  "FEMALE",
  "UNDETERMINED",
  "POSTAL_CODE",
  "BUILDING_TYPE",
  "PRIVATE_HOUSE",
  "APARTMENT",
  "OFFICE",
  "AREA",
  "M",
  "NUMBER_OF_ROOMS",
  "IS_THERE_AN_ATTIC",
  "IS_THERE_A_BASEMENT",
  "PLANNED_MOVING_DATE",
  "SELECTED_SERVICES",
  "MENU",
  "DASHBOARD",
  "DOCUMENTATION",
  "ADMINISTRATOR",
  "A",
  "MY_PROFILE",
  "ORDER_MANAGEMENT",
  "SERVICE_MANAGEMENT",
  "USER_MANAGEMENT",
  "NEW",
  "COMPLETED",
  "REVENUE",
  "SINCE_YESTERDAY",
  "LATEST_ORDERS",
  "SHOW_ALL",
  "ID",
  "CLIENT",
  "DATE",
  "SUM",
  "STATUS",
  "IN_PROGRESS",
  "ASSIGNED",
  "CANCELLED",
  "ANNUAL_REVENUE",
  "ADD_ORDER",
  "FILTER",
  "WITH_ELEVATOR",
  "WITHOUT_ELEVATOR",
  "EDIT",
  "DELETE",
  "YES",
  "NO",
  "ADD_A_SERVICE",
  "NAME",
  "CATEGORY",
  "PRICE",
  "ACTIVE",
  "INACTIVE",
  "ADD_USER",
  "EMPLOYEE",
  "USER",
  "ROLE",
  "VIEW",
  "ORDER_INFORMATION",
  "CREATION_DATE",
  "TOTAL_COST",
  "QUANTITY",
  "INFORMATION_NOT_PROVIDED",
  "CHANGE_STATUS",
  "ACTIONS",
  "PRINT",
  "STATUS_SUCCESSFULLY_CHANGED",
  "FAILED_TO_CHANGE_STATUS",
  "THIS_ORDER_WAS_NOT_FOUND",
  "SERVICE_CATEGORY_MANAGEMENT",
  "DESCRIPTION",
  "ADD_CATEGORY",
  "THIS_ACTION_CANNOT_BE_UNDONE",
  "NO_RECORDS_FOUND_IN_THE_DATABASE",
  "NUMBER",
  "SIZE",
  "CREATE",
  "LANGUAGE",
  "SELECT_THE_LANGUAGE_IN_WHICH_YOU_WANT_TO_PROVIDE_DATA_FOR_FILLING_IN",
  "SAVE",
  "RESET",
  "IMAGE",
  "ADD",
  "HYPERLINK",
  "CHANGES_SAVED_SUCCESSFULLY",
  "FAILED_TO_SAVE_CHANGES",
  "SERVICE",
  "THE_DATE_MUST_NOT_BE_IN_THE_PAST",
  "ORDER_REQUEST",
  "PASSWORD",
  "ADMINISTRATIVE_PANEL",
  "FORGOT_YOUR_PASSWORD",
  "REMEMBER_ME",
  "SIGN_IN",
  "FAILED_TO_LOG_IN",
  "AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER",
  "INCORRECT_EMAIL_ADDRESS_AND_OR_PASSWORD",
  "SIGN_OUT",
  "FIRST_NAME",
  "LAST_NAME",
  "THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_BY_ANOTHER_USER",
  "SUBJECT",
  "BODY",
  "SENDING_AN_EMAIL",
  "EMAIL_SENT_SUCCESSFULLY",
  "SOME_OF_THE_SELECTED_ROLES_DO_NOT_EXIST",
  "INQUIRY",
  "FAILED_TO_LOAD_YOUR_DATA",
  "ACCESS_TO_THE_PAGE_IS_DENIED",
  "ONLY_ADMINISTRATORS_HAVE_ACCESS_TO_THIS_PAGE",
  "ONLY_ADMINISTRATORS_AND_EMPLOYEES_HAVE_ACCESS_TO_THIS_PAGE",
  "YOU_ARE_ALREADY_LOGGED_IN",
  "AUTHENTICATION_SESSION_EXPIRED",
  "ORDERED_SERVICES",
  "THE_DATE_MUST_NOT_BE_EARLIER_THAN_THE_CURRENT_MOMENT",
  "YOU_HAVE_NOT_SELECTED_ANY_SERVICES",
  "VALUE_MUST_MATCH_PHONE_NUMBER_FORMAT",
  "ENTER_THE_VALUE_IN_INTERNATIONAL_PHONE_NUMBER_FORMAT_I_E_...",
  "ACCOUNT_LOGIN",
  "PROFESSIONAL_ORGANIZATION_OF_MOVING_TO_FROM_...",
  "MOVING_IN_SWITZERLAND_APARTMENT_MOVING_OFFICE...",
  "INQUIRY_MANAGEMENT",
  "RESOLVED",
  "ADMINISTRATOR_COMMENT",
  "RESOLVE",
  "INQUIRY_RESOLUTION",
  "REVIEW_MANAGEMENT",
  "RATING",
  "PROS",
  "CONS",
  "TEXT",
  "REVIEW",
  "FAILED_TO_OPEN_PRINT_WINDOW",
  "NEW_ORDER",
  "NEW_INQUIRY",
  "NEW_REVIEW",
  "SOMETHING_HAPPENED",
  "MARK_AS_READ",
  "FAILED_TO_MARK_NOTIFICATION_AS_READ",
  "MARK_ALL_AS_READ",
  "FAILED_TO_MARK_ALL_NOTIFICATIONS_AS_READ",
  "NOTIFICATION",
  "ORDER_CREATION",
  "SERVICE_CREATION",
  "CATEGORY_CREATION",
  "USER_CREATION",
  "ORDER_CREATED",
  "SERVICE_CREATED",
  "CATEGORY_CREATED",
  "USER_CREATED",
  "INQUIRY_CREATED",
  "REVIEW_CREATED",
  "ORDER_REQUEST_CREATED",
  "FAILED_TO_CREATE_ORDER",
  "FAILED_TO_CREATE_SERVICE",
  "FAILED_TO_CREATE_CATEGORY",
  "FAILED_TO_CREATE_USER",
  "FAILED_TO_CREATE_INQUIRY",
  "FAILED_TO_CREATE_REVIEW",
  "FAILED_TO_CREATE_ORDER_REQUEST",
  "ORDER_DELETED",
  "SERVICE_DELETED",
  "CATEGORY_DELETED",
  "USER_DELETED",
  "REVIEW_DELETED",
  "INQUIRY_DELETED",
  "FAILED_TO_DELETE_ORDER",
  "FAILED_TO_DELETE_SERVICE",
  "FAILED_TO_DELETE_CATEGORY",
  "FAILED_TO_DELETE_USER",
  "FAILED_TO_DELETE_REVIEW",
  "FAILED_TO_DELETE_INQUIRY",
  "ORDER_NOT_FOUND",
  "SERVICE_NOT_FOUND",
  "CATEGORY_NOT_FOUND",
  "USER_NOT_FOUND",
  "REVIEW_NOT_FOUND",
  "INQUIRY_NOT_FOUND",
  "NOTIFICATION_NOT_FOUND",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_ORDER",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SERVICE",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_USER",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_REVIEW",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_INQUIRY",
  "ORDER_EDITING",
  "SERVICE_EDITING",
  "CATEGORY_EDITING",
  "USER_EDITING",
  "REVIEW_EDITING",
  "INQUIRY_EDITING",
  "EDITING_ORDERED_SERVICES",
  "FAILED_TO_PRINT_ORDER",
  "FAILED_TO_SEND_EMAIL",
  "FAILED_TO_SIGN_OUT",
  "CONTACT",
  "YOU_HAVE_NO_NOTIFICATIONS",
  "NO_REVIEWS_YET",
  "WRITE_A_REVIEW",
  "WRITING_A_REVIEW",
  "ORDER_ID",
  "PAGE_NOT_FOUND",
  "IT_LOOKS_LIKE_THE_PAGE_...",
  "HOME",
  "RETURN_TO_THE_MAIN_PAGE",
  "CALCULATE",
  "CALCULATE_THE_COST_OF_MOVING",
  "GO_TO",
  "PERSONAL_DATA_UPDATED",
  "FAILED_TO_UPDATE_PERSONAL_DATA",
  "ROLE_DATA_UPDATED",
  "FAILED_TO_UPDATE_ROLE_DATA",
  "PAID",
  "UNPAID",
  "ONLY_IMAGES_IN_JPG_PNG_SVG_FORMATS_ARE_ACCEPTED",
  "FAILED_TO_SAVE_IMAGE",
  "FAILED_TO_DELETE_PREVIOUS_IMAGE",
  "ARE_YOU_SURE_YOU_WANT_TO_CLEAR_FORM_DATA",
  "MAX",
  "REVIEW_DETAILS",
  "ORDER_NUMBER",
  "NO.",
  "OPEN_NAVIGATION_MENU",
  "CLOSE_NAVIGATION_MENU",
  "PLEASE_PROVIDE_THIS_INFORMATION_ONLY_IF_YOU_WOULD_LIKE_US_TO_CONTACT_YOU",
  "THIS_INFORMATION_WILL_NOT_BE_AVAILABLE_PUBLICLY",
  "OPTIONAL",
  "PLEASE_PROVIDE_AT_LEAST_ONE_CONTACT_INFORMATION",
  "ORDER_DETAILS",
  "ORDER_SUMMARY",
  "CUSTOMER_SUPPORT",
  "APPROVED",
  "REJECTED",
  "APPROVE",
  "DISAPPROVE",
  "REVIEW_SUCCESSFULLY_APPROVED",
  "FAILED_TO_APPROVE_REVIEW",
  "MY_ORDERS",
  "DELETE_ALL",
  "THIS_IS_SIMPLY_A_LIST_OF_ORDERS...",
  "DELETING_A_SPECIFIC_OR_ALL_ORDERS...",
  "IF_YOU_NEED_TO_CHANGE_ANY_INFORMATION...",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_ORDERS",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_ORDER_N",
  "YOU_HAVEN_T_CREATED_ANY_ORDERS_YET",
  "YOUR_REVIEW_WILL_BE_PUBLISHED_AFTER...",
  "CHANGE_PASSWORD",
  "PASSWORD_CHANGE",
  "CURRENT_PASSWORD",
  "NEW_PASSWORD",
  "REPEAT_NEW_PASSWORD",
  "PASSWORDS_DO_NOT_MATCH",
  "PASSWORD_CHANGED",
  "FAILED_TO_CHANGE_PASSWORD",
  "CURRENT_PASSWORD_IS_INCORRECT",
  "INSUFFICIENT_RIGHTS_TO_PERFORM_THIS_ACTION",
  "CASH_PAYMENT_IS_POSSIBLE",
  "WE_HAVE_SPECIAL_OFFERS_FOR_SENIORS",
  "WE_PROVIDE_A_10_DISCOUNT_FOR_STUDENTS",
  "ABOUT_US",
  "PASSWORD_RESET",
  "ENTER_THE_EMAIL_ADDRESS_ASSOCIATED_WITH_YOUR_ACCOUNT...",
  "RESET_PASSWORD",
  "PASSWORD_RESET_SUCCESSFUL",
  "AN_EMAIL_WITH_A_NEW_PASSWORD_HAS_BEEN_SENT_TO_YOUR_ADDRESS",
  "FAILED_TO_SEND_PASSWORD_RESET_REQUEST",
  "AN_ACCOUNT_WITH_THE_SPECIFIED_EMAIL_ADDRESS_WAS_NOT_FOUND",
  "ABOUT_US_CHAPTER_1_TITLE",
  "ABOUT_US_CHAPTER_1_PARAGRAPH",
  "ABOUT_US_CHAPTER_2_TITLE",
  "ABOUT_US_CHAPTER_2_PARAGRAPH_1",
  "ABOUT_US_CHAPTER_2_PARAGRAPH_2",
  "ABOUT_US_CHAPTER_3_TITLE",
  "ABOUT_US_CHAPTER_3_PARAGRAPH_1",
  "ABOUT_US_CHAPTER_3_PARAGRAPH_2",
  "ABOUT_US_CHAPTER_4_TITLE",
  "ABOUT_US_CHAPTER_4_PARAGRAPH_1",
  "ABOUT_US_CHAPTER_4_PARAGRAPH_2",
  "SHOW_MY_ORDERS",
  "HIDE_MY_ORDERS",
  "QR_CODE_TO_GO_TO_THIS_SITE",
  "ALL_SERVICES_BELONGING_TO_THIS_CATEGORY_WILL_BE_DELETED",
  "THE_ORDER_CANNOT_BE_UPDATED_BECAUSE_IT_HAS_ALREADY_BEEN_FULFILLED",
  "CHANGE_OF_STATUS",
  "THE_ORDER_STATUS_IS_COMPLETED_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_IT_TO_NEW",
  "CHANGE_PAYMENT_STATUS",
  "PAYMENT_STATUS_CHANGE",
  "PAYMENT_STATUS_CHANGED",
  "FAILED_TO_CHANGE_PAYMENT_STATUS",
  "MOST_LIKELY_IT_WAS_DELETED",
  "SETTINGS",
  "CLOSE",
  "CONSENT_MODAL_TITLE",
  "CONSENT_MODAL_DESCRIPTION",
  "CONSENT_MODAL_ACCEPT_ALL",
  "CONSENT_MODAL_ACCEPT_NECESSARY",
  "CONSENT_PREFERENCES_MODAL_TITLE",
  "CONSENT_PREFERENCES_MODAL_SAVE_PREFERENCES",
  "CONSENT_PREFERENCES_MODAL_SERVICE",
  "CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_TITLE",
  "CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_DESCRIPTION",
  "CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_TITLE",
  "CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_DESCRIPTION",
  "CONSENT_PREFERENCES_MODAL_SERVICE_ANALYTICS_STORAGE",
  "CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_TITLE",
  "CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_DESCRIPTION",
  "CONSENT_PREFERENCES_MODAL_SERVICE_AD_STORAGE",
  "CONSENT_PREFERENCES_MODAL_SERVICE_AD_USER_DATA",
  "CONSENT_PREFERENCES_MODAL_SERVICE_AD_PERSONALIZATION",
  "CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_TITLE",
  "CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_DESCRIPTION",
  "CONSENT_PREFERENCES_MODAL_SERVICE_FUNCTIONALITY_STORAGE",
  "CONSENT_PREFERENCES_MODAL_SERVICE_PERSONALIZATION_STORAGE",
  "CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_TITLE",
  "CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_DESCRIPTION",
  "CONSENT_PREFERENCES_MODAL_SERVICE_SECURITY_STORAGE",
  "THE_PAGE_LANGUAGE_HAS_CHANGED_BUT_THE_CONTENTS",
  "IF_YOU_ARE_NOT_INTERESTED_IN_THE_CONTENTS",
  "RELOAD_PAGE",
  "CONSENT_SUMMARY_TITLE",
  "CONSENT_SUMMARY_DESCRIPTION",
  "CONSENT_ID",
  "LAST_MODIFIED",
  "CONSENT_SUMMARY_ALLOWED",
  "CONSENT_SUMMARY_PARTIALLY_ALLOWED",
  "CONSENT_SUMMARY_BLOCKED",
]);
const TranslationKey = zTranslationKey.Values;
type TranslationKey = z.infer<typeof zTranslationKey>;

export { TranslationKey as Tk };
